import { createRoot } from 'react-dom/client';

import { App } from '@/App';

import '@/styles/index.scss';
import '@fontsource-variable/nunito-sans/full.css';

createRoot(document.getElementById('root')!).render(<App />);
